'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosGameControllerAOutline = function IoIosGameControllerAOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.7 18.8c0.3 0 0.4 0.1 0.4 0.3v1.8c0 0.2-0.1 0.4-0.4 0.4h-2.7v2.7c0 0.2-0.2 0.4-0.5 0.4h-1.6c-0.2 0-0.4-0.2-0.4-0.4v-2.7h-2.7c-0.3 0-0.4-0.3-0.4-0.5v-1.7c0-0.2 0.1-0.3 0.4-0.3h2.7v-2.8c0-0.2 0.2-0.4 0.4-0.4h1.7c0.2 0 0.4 0.2 0.4 0.4v2.8h2.7z m13.1 3c0.8 0 1.5 0.6 1.5 1.5s-0.7 1.5-1.5 1.5-1.5-0.7-1.5-1.5 0.6-1.5 1.5-1.5z m-3.3-3.3c0.9 0 1.5 0.6 1.5 1.5s-0.6 1.5-1.5 1.5-1.6-0.6-1.6-1.5 0.7-1.5 1.6-1.5z m6.6 0c0.9 0 1.5 0.6 1.5 1.5s-0.6 1.5-1.5 1.5-1.5-0.6-1.5-1.5 0.7-1.5 1.5-1.5z m-3.3-3.3c0.8 0 1.5 0.7 1.5 1.5s-0.7 1.6-1.5 1.6-1.5-0.7-1.5-1.6 0.6-1.5 1.5-1.5z m0.5-2.5h-17.6c-2.1 0-3.9 0.7-5.3 2s-2.1 3.2-2.1 5.2 0.7 4 2.1 5.3 3.2 2.1 5.3 2.1h17.6c2.1 0 3.9-0.7 5.3-2.1s2.2-3.2 2.2-5.3-0.8-3.9-2.2-5.2-3.2-2-5.3-2z m0-1.3c4.8 0 8.7 3.5 8.7 8.5s-3.9 8.7-8.7 8.7h-17.6c-4.8 0-8.7-3.7-8.7-8.7s3.9-8.5 8.7-8.5h17.6z' })
        )
    );
};

exports.default = IoIosGameControllerAOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-game-controller-a-outline.js
// module id = 2650
// module chunks = 168707334958949